import { render, staticRenderFns } from "./admin_shell.vue?vue&type=template&id=ded5e360&scoped=true&"
import script from "./admin_shell.vue?vue&type=script&lang=js&"
export * from "./admin_shell.vue?vue&type=script&lang=js&"
import style0 from "./admin_shell.vue?vue&type=style&index=0&id=ded5e360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5e360",
  null
  
)

export default component.exports